(function($){

  // Retrieves input data from a form and returns it as a JSON object:
  function formToJSON(elements) {
    var indexed_array = {};
    $.map(elements, function(n, i){
        indexed_array[n['name']] = n['value'];
    });

    return indexed_array;
  }
  
  function getUrlString(data) {
    var urlParameters = Object.entries(data).map(function (e) {
      return e.join('=');
    }).join('&');
  
    return urlParameters;
  }

  function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  
  function initForm(selector) {
    selector = selector || '.contact-form, .visite-form, .newsletter-form';
  
    document.querySelectorAll(selector).forEach(function(form) {
      var action = form.getAttribute("data-action"),
        alert = "",
        inputs = form.querySelectorAll("[name]"),
        btn = form.querySelector('[type="button"]'),
        id_form = form.getAttribute('id'),
        class_form = form.getAttribute('class');
  
      // Submit data via Fetch
      form.addEventListener('submit', function(e){
        e.preventDefault();
        e.stopImmediatePropagation();

        if( id_form != "visite-form") {
            $("html, body").animate({
                scrollTop: 0
            }, 1000); 
          }else{
            $('html, body').animate({
               scrollTop: $(".visit-form-content").offset().top + 100
             }, 800);
          }

            if ($(this).serialize()) {
              var dataToSend = formToJSON($(this).serializeArray());
              if(id_form == "contact_form"){
                dataToSend.accepts_marketing = dataToSend.accepts_marketing === "true";
              }
              dataToSend.data_privacy = dataToSend.data_privacy === "true"; 
              
              $.ajax({
                url: action,
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(dataToSend),
                beforeSend: function () {

                //   if( id_form != "visite-form") {
                //     $('[data-alert="error"], [data-alert="success"]')
                //     .removeClass()
                //     .addClass('d-none');
                //     $('[data-alert="sent"]')
                //     .removeClass()
                //     .addClass('alert alert-sent');
                //  }
                },
                success: function (html) {
                  if( id_form == "visite-form") {
                    $(".alert-visite-success.success").removeClass("d-none");
                  }else{
                    $('[data-alert="sent"]').addClass('d-none');
                    $('[data-alert="success"]')
                    .removeClass()
                    .addClass('alert alert-success');
                  }
                  form.reset(); // Reset all form data
                  if (form.classList && form.classList.contains('contact-form')) {
                    // set contact send Datalayer event
                    dataLayer.push({
                      'event':'contact_form_sent'
                     });
                  }

                  if (form.classList && form.classList.contains('newsletter-form')) {
                    dataLayer.push({
                      'event': 'newsletter_subscription'
                    });
                    setCookie("newsletter_subscribed", "true", 365);
                  }

                },
                error: function () {
                  if( id_form == "visite-form") {
                    $(".alert-visite-success.error").removeClass("d-none");
                  }else{
                  $('[data-alert="sent"]').addClass('d-none');
                  $('[data-alert="error"]')
                  .removeClass()
                  .addClass('alert alert-error');
                 }

                  form.reset(); // Reset all form data
                }
            });
          }
      });
    });
    
    var dropdown = $('.ContactFormCountryDropdown');
  
    dropdown.empty();
    
    // Populate dropdown with list of provinces
  $.getJSON('https://cdn.shopify.com/s/files/1/0571/1213/3782/files/country_list.json', function (countries) {
    fetch('/browsing_context_suggestions.json')
      .then((resp) => resp.json())
      .then(function(data){
        const country = data.detected_values.country.name;
        const getRegExp = new RegExp(country)
        $.each(countries, function (key, entry) {
          if ( getRegExp.test(entry.name) ) {
            dropdown.append($('<option></option>').attr({
              'value': entry.value,
              'selected': 'selected'
            }).text(entry.name));
          } else {
            dropdown.append($('<option></option>').attr('value', entry.name).text(entry.name));
          }
        })
      })
  });
    
    $("#ContactFormAcceptsMarketing").on('change', function() {
      if ($(this).is(':checked')) {
        $(this).attr('value', 'true');
      } else {
        $(this).attr('value', 'false');
      }
    });
    $("#ContactFormDataPrivacy").on('change', function() {
      if ($(this).is(':checked')) {
        $(this).attr('value', 'true');
      } else {
        $(this).attr('value', 'false');
      }
    });
    
    $("#NewsletterFormAcceptsMarketing").on('change', function() {
      if ($(this).is(':checked')) {
        $(this).attr('value', 'true');
      } else {
        $(this).attr('value', 'false');
      }
    });
  }
  initForm();
  })(jQuery);
  /* end custom contact form fields and submission */
// Insert any custom theme js here...
